function hideLoadingSpinner(elementId) {
  const spinnerElement = document.getElementById(elementId);
  if (spinnerElement) {
    spinnerElement.style.display = 'none';
  }
}

export { hideLoadingSpinner };
